import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyBZipa46MK8AHZ7yV1iFmd8V_ZLt7ETfdo",
  authDomain: "nextdriv-ff82c.firebaseapp.com",
  projectId: "nextdriv-ff82c",
  storageBucket: "nextdriv-ff82c.firebasestorage.app",
  messagingSenderId: "1082786953682",
  appId: "1:1082786953682:web:ddfccd0ae813f344e1f00b",
  measurementId: "G-3ECSR68LZB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Keep the user logged in until the tab is closed
setPersistence(auth, browserSessionPersistence).catch(error => {
  console.error("Error setting auth persistence:", error)
})

export default app;

// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";


// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBZipa46MK8AHZ7yV1iFmd8V_ZLt7ETfdo",
//   authDomain: "nextdriv-ff82c.firebaseapp.com",
//   projectId: "nextdriv-ff82c",
//   storageBucket: "nextdriv-ff82c.firebasestorage.app",
//   messagingSenderId: "1082786953682",
//   appId: "1:1082786953682:web:09d740a9c99340b6e1f00b",
//   measurementId: "G-KNEE4H1HXY"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// export const auth = getAuth(app);
// export const db = getFirestore(app);